module.exports = __webpack_public_path__ + "static/media/FR-74.cc9dc0cf.geojson";